import React, { useEffect, useRef } from "react";

import { useUnresolvedDispute } from "@common/components/hooks/useUnresolvedDispute";
import UnresolvedDisputeForm from "@common/components/shared/UnresolvedDispute/UnresolvedDisputeForm";
import UnresolvedDisputeAction from "@common/redux/actions/UnresolvedDisputeAction";
import { FormProvider } from "react-hook-form";
import { GAMBLING_DISPUTE_TYPE } from "../details/EventDetailsForm";
import useComplianceView from "@hooks/useComplianceView";
import useLinkedAlert from "@common/components/hooks/useLinkedAlert.js";
import useLinkSession from "@common/components/hooks/useLinkSession";

import {
  parseGamblingDisputeResponse,
  prepareCustomers,
} from "@common/components/helpers/compliance.js";
import { Loader } from "semantic-ui-react";
import ComplianceHeader from "../ComplianceHeader";
import useIncidentContainer from "../../../hooks/useIncidentContainer";

const UnresolvedDisputeContainer = () => {
  const sigPad = useRef({});
  const {
    methods,
    methods: { reset },
  } = useUnresolvedDispute(sigPad);
  const {
    formLoading,
    incident,
    incident: {
      record,
      record: {
        id,
        gamblingDispute,
        incidentType: { name },
        alerts,
      },
    },
  } = useComplianceView();
  const { onRowUpdate } = useIncidentContainer();
  const { getComplianceSessionsByGuids } = useLinkSession();
  const { setState } = useLinkedAlert();

  useEffect(() => {
    if (name !== GAMBLING_DISPUTE_TYPE) {
      return;
    }
    UnresolvedDisputeAction.dispatch({
      customer: prepareCustomers(gamblingDispute),
      signature: record?.gamblingDispute?.signature,
    });

    const formData = parseGamblingDisputeResponse(incident);

    getComplianceSessionsByGuids("", record?.gamblingDispute?.sessionGuids);
    setState({ linkedAlertData: alerts });

    reset(formData);
  }, [record]);

  if (formLoading) {
    return <Loader active />;
  }

  return (
    <FormProvider {...methods}>
      <ComplianceHeader
        title="Unresolved Gambling Dispute"
        loadRecord={onRowUpdate}
      />
      <UnresolvedDisputeForm key={id} sigPad={sigPad} />
    </FormProvider>
  );
};

export default UnresolvedDisputeContainer;
